import axios from 'config/api';
import {
  USER_ALTER_PASSWORD_SUCCESS,
  USER_ALTER_PASSWORD_ERROR,
} from 'config/constants';

export async function resetPassword(email) {
  return axios
    .put(`/recover`, { email: email })
    .then(response => {
      const { data, status } = response;
      console.warn('resetPassword', data);
      if (status === 200) {
        console.warn('status', status);
        return {
          type: USER_ALTER_PASSWORD_SUCCESS,
          data: data,
        };
      }

      throw response;
    })
    .catch(error => {
      const {
        response: { data, status },
      } = error;
      if (data && (status === 400 || status === 403 || status === 422)) {
        return {
          type: USER_ALTER_PASSWORD_ERROR,
          message: data.error,
        };
      }
      throw error;
    });
}
